import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Select, Flex, Spin, Tag } from 'antd';
import ninjaApi from 'store/redux/apis';
import NetworkIcon from 'components/NetworkIcon/NetworkIcon';
import { StatusFormatter } from 'components/tables/NinjaTable/formatters';
import debounce from 'common/debounce';
import { LoadingOutlined } from '@ant-design/icons';

const ConversionSelect = ({ onChange, value, mode = 'tag', ...props }) => {
  const containerRef = useRef(null);
  const selectRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState('100%');
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [getConversionListQuery, { isFetching, isLoading, data = [] }] =
    ninjaApi.useLazyGetConversionListQuery();

  const fetchConversions = useCallback(() => {
    getConversionListQuery({ search }).unwrap();
  }, [search, getConversionListQuery]);

  useEffect(() => {
    if (open) fetchConversions();
  }, [open, fetchConversions]);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setMaxWidth(containerRef.current.offsetWidth);
      }
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const handleChange = (val) => onChange?.(val);
  const handleDropdownVisibleChange = (visible) => {
    setOpen(visible);
    if (!visible) setSearch('');
  };
  const handleSearch = debounce((val) => setSearch(val), 200);

  return (
    <div ref={containerRef} className='w-full'>
      <Select
        ref={selectRef}
        className='w-full'
        style={{ maxWidth }}
        open={open}
        mode={mode}
        placeholder='Select Conversion'
        value={value}
        allowClear
        maxTagCount='responsive'
        onChange={handleChange}
        onSearch={handleSearch}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        notFoundContent={
          isFetching ? <Spin indicator={<LoadingOutlined spin />} size='small' /> : null
        }
        {...props}
      >
        {!isLoading &&
          data?.data?.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              <Flex gap='small' align='center'>
                {item.status && <StatusFormatter row={item} title={false} />}
                <NetworkIcon network={item.network} size={15} />
                <span className='font-medium'>{item.name}</span>

                {item?.account?.name && (
                  <>
                    <span className='text-gray-400'>•</span>
                    <Tag bordered={false} color='blue' className='text-xs font-medium'>
                      {item.account.name}
                    </Tag>
                  </>
                )}

                {item?.type && (
                  <>
                    <span className='text-gray-400'>•</span>
                    <Tag bordered={false} color='gold' className='text-xs font-medium'>
                      {item.type}
                    </Tag>
                  </>
                )}
              </Flex>
            </Select.Option>
          ))}
      </Select>
    </div>
  );
};

export default ConversionSelect;
